import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, TextField, Box, Alert } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  targetLevel?: string;
}

export const KillSwitchModal: React.FC<Props> = ({ open, onClose, onConfirm, targetLevel = 'LEVEL_5_FORCE_SQUARE_OFF' }) => {
  const [confirmationText, setConfirmationText] = useState('');
  const REQUIRED_PHRASE = 'FORCE NIFTY FLATTEN';
  const isMatch = confirmationText.trim().toUpperCase() === REQUIRED_PHRASE;

  const handleConfirm = () => {
    if (isMatch) {
      onConfirm();
      setConfirmationText('');
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1.5, color: '#DC2626', bgcolor: '#FEF2F2' }}>
        <WarningAmberIcon sx={{ fontSize: 28 }} />
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          CONFIRM EMERGENCY ACTION: {targetLevel}
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ mt: 2 }}>
        <Alert severity="error" sx={{ mb: 2.5, fontWeight: 500 }}>
          You are about to execute a high-impact risk action that will immediately halt strategy trading and market-exit all active NIFTY positions!
        </Alert>

        <Typography variant="body2" sx={{ color: '#475569', mb: 2 }}>
          To confirm this emergency override, type <strong>{REQUIRED_PHRASE}</strong> in the field below:
        </Typography>

        <TextField
          fullWidth
          size="small"
          placeholder={REQUIRED_PHRASE}
          value={confirmationText}
          onChange={(e) => setConfirmationText(e.target.value)}
          autoFocus
          sx={{
            '& input': {
              fontFamily: "'Roboto Mono', monospace",
              fontWeight: 700,
              letterSpacing: 1,
            },
          }}
        />
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2.5 }}>
        <Button onClick={onClose} variant="outlined" sx={{ color: '#64748B', borderColor: '#CBD5E1' }}>
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          disabled={!isMatch}
          sx={{
            bgcolor: '#DC2626',
            '&:hover': { bgcolor: '#B91C1C' },
            fontWeight: 700,
          }}
        >
          EXECUTE EMERGENCY OVERRIDE
        </Button>
      </DialogActions>
    </Dialog>
  );
};
